import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { QuestionManagementService } from 'src/app/Services/question-management/question-management.service';
import { QuestionAddEditComponent } from '../question-add-edit/question-add-edit.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FlashcardListModalComponent } from '../flashcard-list-modal/flashcard-list-modal.component';

@Component({
  selector: 'app-flashcard-external-references-report',
  templateUrl: './flashcard-external-references-report.component.html',
  styleUrls: ['./flashcard-external-references-report.component.css']
})
export class FlashcardExternalReferencesReportComponent implements OnInit {
  @ViewChild('flashcardEditorHost') flashcardEditorHost?: QuestionAddEditComponent;

  reportRows: any[] = [];
  isLoading = false;
  editorSubjectById: any;
  showFlashcardEditor = false;
  flashCardId: string = '';
  globalFlashCardList: any[] = [];
  searchString = 'src="https://';
  stringToExclude: string | null = null;
  closeTriggerValue: object | null = null;

  constructor(
    private service: QuestionManagementService,
    private toastr: ToastrService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.fetchReport();
  }

  fetchReport(): void {
    this.isLoading = true;
    const payload = {
      SearchString: 'src="https://',
      StringToExclude: null
    };

    this.service.GetSearchStringInFlashcard(payload).subscribe(
      (response: any) => {
        this.isLoading = false;
        const apiData = response?.data || response?.Data || [];
        this.reportRows = Array.isArray(apiData) ? apiData : [];

        const isFailed = response?.status === false || response?.Status === false;
        if (isFailed) {
          this.toastr.error(response?.message || response?.Message || 'Failed to fetch report');
        }
      },
      () => {
        this.isLoading = false;
        this.toastr.error('Failed to fetch report');
      }
    );
  }

  clearFilters(): void {
    this.reportRows = [];
  }

  openFlashcardEditor(row: any, event?: Event): void {
    event?.preventDefault();

    const flashcardId = row?.Flashcard_ID || row?.FlashCard_ID;
    if (!flashcardId) {
      this.toastr.error('Flashcard ID is not available.');
      return;
    }

    // Get the subject ID - you may need to fetch it from the API
    // For now, we'll open the editor directly with the flashcard ID
    this.flashCardId = flashcardId;
    this.showFlashcardEditor = true;
  }

  closeEventTrigger(): void {
    this.closeTriggerValue = { hash: Date.now() };
  }

  closeFaDialog(event?: any): void {
    this.showFlashcardEditor = false;
    this.closeTriggerValue = null;
  }
}
